import { setLocale } from 'yup';

import { T, ThirdPartyModule } from '@oaknorth/util-intl';

/**
 * i18n module that updates the global yup validation messages when the language is changed
 */
export const yupI18next: ThirdPartyModule = {
  type: '3rdParty',

  init() {
    setLocale({
      mixed: {
        default: () => T`fieldValidation.invalid`,
        required: () => T`fieldValidation.required`,
        oneOf: ({ values }) => T('fieldValidation.oneOf', { options: values }),
        notOneOf: ({ values }) => T('fieldValidation.notOneOf', { options: values }),
        defined: () => T`fieldValidation.defined`,
      },
      string: {
        length: ({ length }) => T('fieldValidation.string.exactLength', { count: length }),
        min: ({ min }) => T('fieldValidation.string.minLength', { count: min }),
        max: ({ max }) => T('fieldValidation.string.maxLength', { count: max }),
        matches: () => T`fieldValidation.string.pattern`,
        email: () => T`fieldValidation.string.email`,
        url: () => T`fieldValidation.string.url`,
        uuid: () => T`fieldValidation.string.uuid`,
      },
      number: {
        min: ({ min }) => T('fieldValidation.number.min', { min }),
        max: ({ max }) => T('fieldValidation.number.max', { max }),
        lessThan: ({ less }) => T('fieldValidation.number.lessThan', { less }),
        moreThan: ({ more }) => T('fieldValidation.number.moreThan', { more }),
        positive: () => T`fieldValidation.number.positive`,
        negative: () => T`fieldValidation.number.negative`,
        integer: () => T`fieldValidation.number.integer`,
      },
      date: {
        min: ({ min }) => T('fieldValidation.date.min', { min: new Date(min) }),
        max: ({ max }) => T('fieldValidation.date.max', { max: new Date(max) }),
      },
      array: {
        length: ({ length }) => T('fieldValidation.array.exactLength', { count: length }),
        min: ({ min }) => T('fieldValidation.array.minLength', { count: min }),
        max: ({ max }) => T('fieldValidation.array.maxLength', { count: max }),
      },
    });
  },
};
